import { useOverlays } from "contexts/OverlayContext";
import { PlainModal } from "@design-system/Modal/Modal";
import { AddOrganizationMemberModal } from "./AddOrganizationMemberModal";

export const AddOrganizationMemberModalOverlay = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("organizationAddTeamMember");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <PlainModal show={!overlayIsClosing} onHide={closeOverlay}>
            <AddOrganizationMemberModal
                organization={overlayInfo.data.organization}
                providedEmail={overlayInfo.data.email}
                providedRole={overlayInfo.data.role}
                initialWorkspaceIds={overlayInfo.data.initialWorkspaceIds}
                onInvited={overlayInfo.data.onInvited}
                closeModal={closeOverlay}
            />
        </PlainModal>
    );
};
